import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '@/lib/dashboardApi'
import useAvailabilityStore from '@/stores/availability.store'

export function HospitalSelector() {
  const store = useAvailabilityStore()

  const { data, isLoading } = useQuery({
    queryKey: ['dashboard', 'region', 'dakar'],
    queryFn: () => dashboardApi.getRegion('dakar'),
    staleTime: 5 * 60 * 1000,
  })

  const structures = data?.structures ?? []

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const code = e.target.value
    const selected = structures.find((s) => s.identifierCode === code)
    if (selected) {
      store.setStructure(selected.identifierCode, selected.name)
      store.resetAll()
    }
  }

  if (isLoading) {
    return <p className="text-sm text-neutral-400 mt-0.5 animate-pulse">Chargement des structures...</p>
  }

  return (
    <select
      value={store.structureId || ''}
      onChange={handleChange}
      className="text-sm text-neutral-600 mt-0.5 bg-transparent border-none outline-none cursor-pointer hover:text-neutral-900 transition-colors"
    >
      <option value="">-- Choisir un hôpital --</option>
      {structures.map((s) => (
        <option key={s.identifierCode} value={s.identifierCode}>
          {s.name} ({s.identifierCode})
        </option>
      ))}
    </select>
  )
}
